import { MAX_ENTRY_BODY_LENGTH } from './entryBodyLimit';

function charCountTone(length: number, max: number): string {
    if (length > max) return 'text-red-500';
    if (length >= max * 0.9) return 'text-amber-600';
    return 'text-gray-400';
}

// Live plain-text counter for an entry's rich-text body - shared by the
// create page and the timeline's add/edit composer so the cap reads and
// enforces identically everywhere (see entryBodyLimit.ts).
export function EntryBodyCharCount({ length }: { length: number }) {
    return (
        <span
            className={`text-[11px] font-medium tabular-nums ${charCountTone(length, MAX_ENTRY_BODY_LENGTH)}`}
        >
            {length} / {MAX_ENTRY_BODY_LENGTH}
        </span>
    );
}
